// Which page the WL editor is mounted on, for the `x-wl-edit-origin` header (guid-1986).
// Only `schedule` edits are tracked server-side; `/schedule-user*` is My-Schedule.
export const getWlEditOrigin = () => {
  const path = window.location?.pathname || '';
  if (/^\/schedule-user(\/|$)/.test(path)) return 'my-schedule';
  if (/^\/schedule(\/|$)/.test(path)) return 'schedule';
  return undefined;
};
